import { render, staticRenderFns } from "./site-sidebar.vue?vue&type=template&id=81285eb4&scoped=true"
import script from "./site-sidebar.vue?vue&type=script&lang=js"
export * from "./site-sidebar.vue?vue&type=script&lang=js"
import style0 from "./site-sidebar.vue?vue&type=style&index=0&id=81285eb4&prod&scoped=true&lang=css"
import style1 from "./site-sidebar.vue?vue&type=style&index=1&id=81285eb4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81285eb4",
  null
  
)

export default component.exports